import React from 'react';
import {Link} from 'react-router-dom'

const FarmerSidebar = () => {

    return (
        <div id="sidebar-wrapper" data-simplebar="" data-simplebar-auto-hide="true">
            <div className="brand-logo">
        <span className="user-profile">
            <Link to="/farmer" className="waves-effect text-white">
                <img src="https://farmkonnectng.com/assets/afd/images/fklogo2.png" className="img-circle"
                     alt="user avatar"/>
            </Link>
        </span>
            </div>
            <ul className="sidebar-menu do-nicescrol">
                <li className="text-center m-0 p-0">
                    {/*<i className="fa fa-map-marker fa-3x text-success pl-2" aria-hidden="true"> </i>*/}
                    <Link to="/farmer" className="waves-effect text-white">
                        <span>Dashboard</span>
                    </Link>
                </li>

                <hr className="border-success mt-0"></hr>
                <div>
                    <i className="fas fa-tractor fa-3x text-success pl-1"> </i>
                    <span className="text-success p-2">Equipment Requests</span>
                </div>
                <li><Link to="/farmer/farm/equipment" className="waves-effect pl-3"> <span>New Request</span></Link>
                </li>
                <li><Link to="/farmer/farm/equipment/view" className="waves-effect pl-3">
                    <span>View Requests</span></Link></li>

                <hr className="border-success"></hr>

                <div>
                    <i className="fas fa-seedling fa-3x text-success pl-2" aria-hidden="true"> </i>
                    <span className="text-success p-3">Farm</span>
                </div>
                <li><Link to="/farmer/farm/add" className="waves-effect pl-3"> <span>Add Farm</span></Link></li>
                <li><Link to="/farmer/farm/manage" className="waves-effect pl-3"> <span>Manage Farm</span></Link></li>

                <hr className="border-success"></hr>
                <div>
                    <i className="fas fa-user-cog fa-3x text-success pl-2" aria-hidden="true"> </i>
                    <span className="text-success p-3">Account Setting</span>
                </div>

                <li><Link to="/farmer/profile" className="waves-effect pl-3"> <span>Edit Profile</span></Link></li>
                <li><Link to="/farmer/change_password" className="waves-effect pl-3">
                    <span>Change Password</span></Link></li>

                <hr className="border-success"></hr>
                <div>
                    <i className="fas fa-wallet fa-3x text-success pl-2" aria-hidden="true"> </i>
                    <span className="text-success p-3">Wallet</span>
                </div>

                <li><Link to="/farmer/wallet" className="waves-effect pl-3"> <span>Transactions</span></Link></li>
                <li><Link to="/farmer/wallet/settings" className="waves-effect pl-3">
                    <span>Wallet Settings</span></Link></li>
            </ul>
        </div>

    )
};


export default FarmerSidebar;